import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormGroup, Input } from "@cofano/cck";
import CountrySelect from "components/selects/CountrySelect";
import { FormErrorMessage } from "components/form/FormErrorMessage";
import { Language } from "utils";
import { LocationSchemaInput, LocationSchemaOutput } from "view/locations/utils/location.schema";

const LocationAddressForm = () => {

	const { control } = useFormContext<LocationSchemaInput, unknown, LocationSchemaOutput>();

	return (
		<React.Fragment>
			<FormGroup label={Language("CLIENT_NAME_ONE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="address.name1"
					control={control}
					render={({ field, formState }) => (
						<React.Fragment>
							<Input {...field} />
							<FormErrorMessage name={field.name} errors={formState.errors} />
						</React.Fragment>
					)} />
			</FormGroup>

			<FormGroup label={Language("CLIENT_NAME_TWO")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="address.name2"
					control={control}
					render={({ field, formState }) => (
						<React.Fragment>
							<Input {...field} />
							<FormErrorMessage name={field.name} errors={formState.errors} />
						</React.Fragment>
					)} />
			</FormGroup>

			<FormGroup label={Language("CLIENT_STREET")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="address.street"
					control={control}
					render={({ field, formState }) => (
						<React.Fragment>
							<Input {...field} />
							<FormErrorMessage name={field.name} errors={formState.errors} />
						</React.Fragment>
					)} />
			</FormGroup>

			<FormGroup label={Language("CLIENT_ZIPCODE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="address.zipCode"
					control={control}
					render={({ field, formState }) => (
						<React.Fragment>
							<Input {...field} />
							<FormErrorMessage name={field.name} errors={formState.errors} />
						</React.Fragment>
					)} />
			</FormGroup>

			<FormGroup label={Language("PLACE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="address.town"
					control={control}
					render={({ field, formState }) => (
						<React.Fragment>
							<Input {...field} />
							<FormErrorMessage name={field.name} errors={formState.errors} />
						</React.Fragment>
					)} />
			</FormGroup>

			<FormGroup label={Language("CLIENT_COUNTRY")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="address.country"
					control={control}
					render={({ field }) => <CountrySelect {...field} clearable />} />
			</FormGroup>
		</React.Fragment>
	);
};

export default LocationAddressForm;
